import React from 'react';

function FollowButton() {
    return (
      <button className="follow-button">Obserwuj</button>
    );
}
  
export default FollowButton;
